'use strict';

var __chunk_2 = require('../constants.js');

var contextHelper = (({
  context,
  extension,
  version
}) => {
  if (typeof context === 'object' && typeof context[__chunk_2.CONTEXT_KEY] === 'object' && typeof context[__chunk_2.CONTEXT_KEY].addExtension === 'function') {
    context[__chunk_2.CONTEXT_KEY].addExtension({
      extension,
      version
    });
  }
});

exports.default = contextHelper;
//# sourceMappingURL=contextHelper.js.map
